import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';
import { t } from '../../../../locales';
import {
  isApp,
  resolvePublicAssets,
  resolveLocalizedText,
} from '../../../../utils/';
import { trackEnrolmentTimes } from '../../../../utils/generalGaEventAnalytics';
import { goto } from '../../../../actions/historyActions';

import ContentWrapper from '../../../../components/ContentWrapper/';
import ImageText from '../../../../components/ImageText/';
import VhisRules from '../../components/VhisRules';
import { EmmaFactory } from '@axa-asia/hk-emma-js';

import {
  getShowStartCampaignButton,
  getRulesAnchor,
  getaxaGoalRulesInfo,
} from '../../selectors/vhisSelectors';
import {
  fetchCampaignStarted,
  anchorToRulesMembership,
  showMembershipTutorial,
} from '../../actions/vhisAction';

// import image
import Arrow from '../../../../assets/images/arrow-right-b@3x.png';
import './style.scss';
import '../../../../common/scss/common.scss';
import {
  getAxaGoalRuleType,
  getLanguage,
} from '../../../../selectors/userSelectors';
import { getAktivoAgreedTnc } from '../../../../selectors/authSelectors';
import { ArrowTab } from '@axa-asia/emma-stylesheet';

interface RulesScreenProps {
  leafletLink: string;
  onFetchCampaignStarted: () => void;
  isAgreedTnc: boolean;
  anchor: string;
  onDownloadDocument: (url: string) => void;
  anchorToMembership: (anchor: string) => void;
  banner?: string;
  smallBanner?: string;
  stepCountPeriod: {
    title?: string;
    content?: string;
    img?: string;
    knowMoreBtn: {
      label?: string;
      deepLinkUrl?: string;
    };
  };
  ruleType?: 'SH' | 'WGP' | 'BOTH';
  onShowMembershipTutorial: (ruleType: 'SH' | 'WGP') => void;
}

export interface RulesScreenState {
  isAnchor: boolean;
  tabIndex: number;
}

class RulesScreen extends Component<RulesScreenProps, RulesScreenState> {
  membershipYearTop: any;

  constructor(props: any) {
    super(props);
    this.goToAppView = this.goToAppView.bind(this);
    this.state = {
      isAnchor: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      const { onFetchCampaignStarted } = this.props;
      onFetchCampaignStarted();
    }, 1000);

    if (isApp()) {
      const title = t(`RULES_AND_REGULATIONS`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }
  }

  anchorToContent() {
    const { anchor, anchorToMembership } = this.props;
    const pathHash = window.location.href.split('#');
    if (anchor || pathHash.length > 1) {
      const anchorEle = document.getElementById(`${anchor || pathHash[1]}`);
      if (anchorEle) {
        if (isApp()) {
          this.scrollToMembershipYear();
          setTimeout(this.scrollToMembershipYear, 1500);
        } else {
          this.scrollToMembershipYear();
        }
      }
      anchorToMembership('');
      this.setState({
        isAnchor: true,
      });
    }
  }

  componentDidUpdate() {
    if (!this.state.isAnchor) {
      this.anchorToContent();
    }
  }

  scrollToMembershipYear = () => {
    if (this.membershipYearTop) {
      this.membershipYearTop.scrollIntoView({ behavior: 'auto' });
    }
  };

  goToAppView(url: string) {
    if (isApp()) {
      EmmaFactory.createInstance().then((e) => {
        e.instance.goTo(url);
      });
    } else {
      goto(url);
    }
  }

  openWindow(url: string) {
    window.open(url);
  }

  render() {
    const checkIsApp = isApp();
    const {
      isAgreedTnc,
      banner,
      stepCountPeriod,
      smallBanner,
      onShowMembershipTutorial,
      ruleType,
    } = this.props;
    const { tabIndex } = this.state;
    const vhisAsClasses = classNames({
      'vhis-as': true,
      'vhis-as--withPaddingBottom': !checkIsApp,
      'axa-goal-rules': true,
    });
    const isUseSmallBanner = document.body.offsetWidth < 500;

    const isBoth = ruleType === 'BOTH';
    const isSH = ruleType === 'SH' || (isBoth && tabIndex === 1);
    const isWGP = ruleType === 'WGP' || (isBoth && tabIndex === 0);
    const tabList = [t(`RULES_TAB_AXA_GOAL`), t(`RULES_TAB_AXA_GOAL_LITE`)];
    const translationPrefix = isSH ? 'SH_' : '';
    return (
      <div className="vhis-rules-container">
        <div className={vhisAsClasses}>
          {!checkIsApp && (
            <h1 className="vhis-rules__title">
              {t(`${translationPrefix}RULES_AND_REGULATIONS`)}
            </h1>
          )}
          {!isUseSmallBanner && banner && (
            <div
              className={`vhis-rules__banner ${!checkIsApp ? 'margin24' : ''}`}
              style={{ backgroundImage: `url(${banner})` }}
            ></div>
          )}
          {isUseSmallBanner && smallBanner && (
            <div
              className={`vhis-rules__banner ${!checkIsApp ? 'margin24' : ''}`}
              style={{ backgroundImage: `url(${smallBanner})` }}
            ></div>
          )}
          {isBoth && (
            <ArrowTab
              value={tabList[tabIndex]}
              onSwitchTab={(tab) => {
                this.setState({ tabIndex: tab.currentTabIndex });
              }}
              tabList={tabList}
            />
          )}
          <ContentWrapper>
            {/* Rules and regulations start */}
            <div className="vhis-rules">
              <p
                className="vhis-rules__sub-title"
                dangerouslySetInnerHTML={{
                  __html: memoSanitize(
                    t(`${translationPrefix}RULES_AND_REGULATIONS_TITLE`),
                  ),
                }}
              ></p>
              <p
                className="vhis-rules__content"
                dangerouslySetInnerHTML={{
                  __html: memoSanitize(
                    t(`${translationPrefix}STARTED_IS_EASY`),
                  ),
                }}
              ></p>
              {checkIsApp && (
                <p className="vhis-rules__content">
                  <b>{t('PARTICIPATED_THI_CAMPAIGN')}</b>
                </p>
              )}
              <div className="vhis-rules__rules">
                <p className="vhis-rules__rules__title">
                  {t(`${translationPrefix}RULES_TITLE`)}
                </p>
                <VhisRules ruleType={isSH ? 'SH' : 'WGP'} />
              </div>
              <div className="vhis-rules__step-count-period">
                <ImageText imgSrc={stepCountPeriod.img} type="rules">
                  <p className="image-text__txt__title">
                    {t(`${translationPrefix}RULE_MEMBERSHIP_YEAR`)}
                  </p>
                  <p className="image-text__txt__content image-text__txt__content--small">
                    {t(`${translationPrefix}RULE_MEMBERSHIP_CONTENT`)}
                  </p>
                </ImageText>
                <a
                  className="vhis-rules__step-count-period__know-more-btn"
                  onClick={() => onShowMembershipTutorial(isSH ? 'SH' : 'WGP')}
                  target="about:blank"
                  data-enable-ga
                  data-ga-type="link"
                >
                  <div className="vhis-rules__step-count-period__know-more-btn__label">
                    {stepCountPeriod.knowMoreBtn.label}
                    <img
                      className="vhis-rules__step-count-period__know-more-btn__arrow"
                      src={Arrow}
                      alt=""
                    />
                  </div>
                </a>
              </div>
              {/* TODO - jira HKEMMA-17424  */}
              {isApp() && !isAgreedTnc && (
                <div className="text-center">
                  <button
                    className="emma-stylesheet-primary-default-button rules-button"
                    onClick={() => {
                      this.goToAppView('emma-vhis/rules-clicked');
                      trackEnrolmentTimes();
                    }}
                    data-enable-ga
                    data-ga-type="button"
                  >
                    {t('START_NOW')}
                  </button>
                </div>
              )}

              <div className="text-center">
                {isApp() ? (
                  <button
                    className="emma-stylesheet-primary-ghost-button rules-button"
                    onClick={() =>
                      this.goToAppView(
                        `emma-home/viewleaflet?extra=${isSH ? 'SH' : 'WGP'}`,
                      )
                    }
                    data-enable-ga
                    data-ga-type="button"
                  >
                    {t('VIEW_LEAFLET')}
                  </button>
                ) : (
                  <button
                    className="emma-stylesheet-primary-ghost-button rules-button"
                    onClick={() =>
                      this.goToAppView('emma-home/mypolicy?id=viewleaflet')
                    }
                    data-enable-ga
                    data-ga-type="link"
                  >
                    {t('VIEW_LEAFLET')}
                  </button>
                )}
              </div>
            </div>
            {/* Rules and regulations end */}
          </ContentWrapper>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const isAgreedTnc = getAktivoAgreedTnc(state);
    const ruleType = ownProps.ruleType || getAxaGoalRuleType(state);
    const anchor = getRulesAnchor(state);
    const axaGoalRulesInfo = getaxaGoalRulesInfo(state);
    const stepCountPeriod = axaGoalRulesInfo.stepCountPeriod || {};
    const stepCountPeriodImg = stepCountPeriod.img
      ? resolvePublicAssets(stepCountPeriod.img)
          .replace('.png', '@3x.png')
          .replace('.jpg', '@3x.jpg')
      : '';
    const lang = getLanguage(state);

    return {
      isAgreedTnc,
      anchor,
      banner: axaGoalRulesInfo.banner
        ? resolvePublicAssets(axaGoalRulesInfo.banner)
            .replace('.png', '@3x.png')
            .replace('.jpg', '@3x.jpg')
        : '',
      smallBanner: axaGoalRulesInfo.smallBanner
        ? resolvePublicAssets(axaGoalRulesInfo.smallBanner)
            .replace('.png', '@3x.png')
            .replace('.jpg', '@3x.jpg')
        : '',
      stepCountPeriod: {
        title: stepCountPeriod.title
          ? resolveLocalizedText(stepCountPeriod.title)
          : '',
        content: stepCountPeriod.content
          ? resolveLocalizedText(stepCountPeriod.content)
          : '',
        img: stepCountPeriodImg,
        knowMoreBtn: {
          label: _.get(stepCountPeriod, `knowMoreBtn.label.${lang}`, ''),
          deepLinkUrl: _.get(stepCountPeriod, 'knowMoreBtn.deepLinkUrl', ''),
        },
      },
      ruleType,
      lang,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onFetchCampaignStarted: () => dispatch(fetchCampaignStarted()),
      anchorToMembership: (anchor: string) =>
        dispatch(anchorToRulesMembership(anchor)),
      onShowMembershipTutorial: (ruleType: 'SH' | 'WGP') =>
        dispatch(showMembershipTutorial(ruleType)),
    };
  }
}

export default connect(
  RulesScreen.mapStateToProps,
  RulesScreen.mapDispatchToProps,
)(RulesScreen);
